import { IPatientWaitingListFiltersParamsBody } from "@/api_framework/api_modals/Patients";
import { IPWLFilterFormFields } from "../components/routes/auth_routes/PatientWaitingList/PWLFilters";
import { useConfiguration } from "./useConfiguration";

export interface IPWLFiltersLocalSet extends IPatientWaitingListFiltersParamsBody {
  formDump: IPWLFilterFormFields;
}

export interface IPWLFiltersLocalGet extends IPatientWaitingListFiltersParamsBody {
  formDump: IPWLFilterFormFields;
}

export const usePWLFilters = (action: "SET" | "GET") => {
  const configuration = useConfiguration();
  // Only access localstorage for Redux use setPWLFilters with dispatch
  const getCachedPWLFilters = (): IPWLFiltersLocalGet | null => {
    try {
      const cachedFilterValues = localStorage.getItem(configuration.localStorage.PWL_FILTERS.key);

      if (cachedFilterValues) {
        const PWLFilters = JSON.parse(cachedFilterValues) as IPWLFiltersLocalGet;
        return PWLFilters;
      }
      return null;
    } catch (e) {
      return null;
    }
  };

  // Cache
  const cachePWLFilters = (filters: IPWLFiltersLocalSet): IPWLFiltersLocalSet | null => {
    // const { formDump, ...restFilters } = filters; // Destructure formDump and the rest of filters

    const filter: any = {
      ...filters, // Spread the remaining properties from filters
      formDump: { ...filters.formDump, created_by: null }, // Spread properties from formDump
      created_by: null, // Set created_by to null
    };

    try {
      localStorage.setItem(configuration.localStorage.PWL_FILTERS.key, JSON.stringify(filter));
      return filter;
    } catch (e) {
      return null;
    }
  };
  return action === "GET" ? { getCachedPWLFilters } : { cachePWLFilters };
};
